module.exports = __webpack_public_path__ + "img/stamp_no.3f8edde1.png";